import React from "react";
import { registerView, View, ViewComponent } from "@frui.ts/views";
import OutagesWidgetViewModel from "../../viewModels/outages/outagesWidgetViewModel";
import { observer } from "mobx-react-lite";

const OutagesWidgetView: ViewComponent<OutagesWidgetViewModel> = observer(({ vm }) => {
  return <View vm={vm.activeChild} />;
});

registerView(OutagesWidgetView, OutagesWidgetViewModel);
